export class TreeNode {
  id: number;
  name: string;
  children: TreeNode[];
  is_branch: boolean;
  type: string;
  constructor(id:number, name: string, is_branch: boolean, children: TreeNode[] = [], type: string = "") {
    this.id = id;
    this.name = name;
    this.is_branch = is_branch;
    this.children = children;
    this.type = type;
  }
   // You could add methods for adding/removing children or other tree manipulations if needed
   addChild(node: TreeNode): void {
    this.children.push(node);
  }

   // Method to add a folder (branch node)
   addFolder(folderId: number, folderName: string): void {
    if (this.is_branch) {
      const newFolder = new TreeNode(folderId, folderName, true);  // A folder is a branch (is_branch = true)
      this.children.push(newFolder);
    } else {
      console.error(`Cannot add a folder under a file: ${this.name}`);
    }
  }

   // Method to add a file (non-branch node)
   addFile(fileId: number,fileName: string): void {
    if (this.is_branch) {
      const newFile = new TreeNode(fileId,fileName, false);  // A file is not a branch (is_branch = false)
      this.children.push(newFile);
    } else {
      console.error(`Cannot add a file under a file: ${this.name}`);
    }
  }

   // Method to update the name of a node by its name
   updateNameById(id: number, newName: string): boolean {
    // If the current node's name matches the given name, update it
    if (this.id == id) {
      this.name = newName;
      return true; // Return true if the name was updated
    }

    // Otherwise, check if any child nodes match the given name
    for (const child of this.children) {
      // Ensure child is a TreeNode instance before calling updateNameById
      if (child instanceof TreeNode) {
        const updated = child.updateNameById(id, newName); // Recursively search children
        if (updated) {
          return true; // If a child node was updated, return true
        }
      }
    }

    return false; // Return false if no matching node was found
  }

  removeChild(id: number): boolean {
    // First, look for the child directly in this node's children
    const initialLength = this.children.length;
    this.children = this.children.filter(child => child.id != id);
    
    // If we found and removed the child, return true
    if (this.children.length < initialLength) {
      return true;
    }
    
    // If not found directly, recursively search in all folder children
    for (let i = 0; i < this.children.length; i++) {
      const child = this.children[i];
      if (child.is_branch) {
        // If this child is a folder, search inside it
        const removed = child.removeChild(id);
        if (removed) {
          return true; // Child was found and removed in this subfolder
        }
      }
    }
    
    // Child not found in this node or any of its descendants
    return false;
  }
  
  // Helper method to find a node by ID (recursive)
  findNodeById(id: number): TreeNode | null {
    // Check if current node matches
    if (this.id == id) {
      return this;
    }
    
    // Check all children
    for (const child of this.children) {
      if (child instanceof TreeNode) {
        const foundNode = child.findNodeById(id);
        if (foundNode) {
          return foundNode;
        }
      }
    }
    
    // Not found
    return null;
  }
  
  // Helper to determine if a node is a descendant of this node
  isDescendant(possibleDescendant: TreeNode): boolean {
    // Check all children
    for (const child of this.children) {
      if (child.id == possibleDescendant.id) {
        return true;
      }
      
      // If this child is a folder, recursively check its children
      if (child.is_branch) {
        if (child.isDescendant(possibleDescendant)) {
          return true;
        }
      }
    }
    
    return false;
  }
  
  // Find the parent of a node by ID
  getParentOf(childId: number): TreeNode | null {
    // Check if any direct children match the ID
    for (const child of this.children) {
      if (child.id == childId) {
        return this;
      }
    }
    
    // Recursively check all folder children
    for (const child of this.children) {
      if (child.is_branch) {
        const parent = child.getParentOf(childId);
        if (parent) {
          return parent;
        }
      }
    }
    
    return null;
  }
}


